import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query DealsBrands(
    $sort: DealListSort
    $uuids: [String]
    $tags: [String]
    $types: [DealType]
    $statuses: [DealStatus!]
    $locale: String
    $q: String
    $ignoreBlacklist: Boolean
    $ignorePackage: Boolean
    $ttOnly: Boolean
    $provider: PendingDealProvider
    $regions: [ID!]
    $isRewards: Boolean
    $reviewState: DealReviewState
    $brandTagIds: [String!]
    $excludeBrandId: String
    $customDealType: String
  ) {
    dealsBrands(
      sort: $sort
      uuids: $uuids
      tags: $tags
      types: $types
      statuses: $statuses
      locale: $locale
      q: $q
      ignoreBlacklist: $ignoreBlacklist
      ignorePackage: $ignorePackage
      ttOnly: $ttOnly
      provider: $provider
      regions: $regions
      isRewards: $isRewards
      reviewState: $reviewState
      brandTagIds: $brandTagIds
      excludeBrandId: $excludeBrandId
      customDealType: $customDealType
    ) {
      logoUrl
      slug
      count
      label
      brand {
        uuid
      }
    }
  }
`

export const dealsBrandsQueryKey = getQueryNames(query)[0]

export default query
